import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class SoloModeProvider {
  private storageKeyPrefix = 'isSoloMode';
  private queryParamName = 'solo';
  private url: URL;

  constructor(private storageService: StorageService) {}

  storeState(): void {
    const url = new URL(location.href);
    const isSoloMode = this.readQueryParam(url);

    this.removeQueryParam(url);
    this.storeSoloMode(url, isSoloMode);
  }

  private readQueryParam(url: URL) {
    const { searchParams } = url;
    const isSoloMode = searchParams.get(this.queryParamName) === '1';

    return isSoloMode;
  }

  private storeSoloMode(url: URL, isSoloMode: boolean): void {
    this.url = url;
    this.storageService.set(this.storageKey, isSoloMode);
  }

  private removeQueryParam(url: URL): void {
    const stateObj = null;
    const unused = '';

    url.searchParams.delete(this.queryParamName);
    history.replaceState(stateObj, unused, url.toString());
  }

  get isSoloMode(): boolean {
    const isSoloMode = this.storageService.get(this.storageKey);

    return isSoloMode;
  }

  get storageKey(): string {
    return this.storageKeyPrefix + '-' + this.url.toString();
  }
}
